import MojitoPresentation from 'mojito/presentation';

const { NavigationPathBuilder } = MojitoPresentation.Base.Navigation;

/**
 * Builds the navigation intent data for a promoted main event.
 *
 * SportsContent store events nest routing data under `details` (unlike the flat search-API result
 * shape), so the meeting id and in-play flag are read from there. A promoted race event whose
 * meeting id was read from the root would miss the race branch and route to the wrong (non-race)
 * event page.
 *
 * @param {object} event - Store event to navigate to.
 * @returns {object} Navigation data describing the target route.
 * @function getNavigationData
 * @memberof Mojito.Applications.Sports.Search
 */
export const getNavigationData = event => {
    const { id, sportId, details = {} } = event;
    const { meetingId, inPlay } = details;
    if (meetingId) {
        return NavigationPathBuilder.toRaceEvent(sportId, meetingId, id);
    }
    return inPlay
        ? NavigationPathBuilder.toInplayEvent(id)
        : NavigationPathBuilder.toSportEvent(sportId, id);
};
